/* dg-spin-wh.js: copy of dg-spin.js for the 49" WHITE (same tooling as the 165 Hz, white finish). Uses the 165 Hz's dgs-49hex-* model unchanged; only the shader re-tones the housing white. dg-spin.js is untouched. */
/* Deco Gear photo-projected turntable (production build of proto/mock/duo/spin.js).
   The fitted 3D shape of the monitor is coloured by projecting the REAL factory renders onto it from the
   exact camera each render was taken from, with per-view visibility (depth maps) and view-dependent blending.
   Requires window.THREE (r128).

   Shopify asset URLs are flat CDN URLs, so every file is passed explicitly:
     DGSpin.mount(canvas, {
       mesh:     '{{ "dgs-49hex-mesh.bin" | asset_url }}',          // packed mesh (.bin; legacy model.json also accepted)
       views:    '{{ "dgs-49hex-views.json" | asset_url }}',        // camera poses
       textures: { front: '{{ "dgs-49hex-front.webp" | asset_url }}', ... },  // keyed by view name (falls back to base + view.img)
       screen:   { screenX: 583, screenY0: 214, screenY1: 555 },    // optional lit-screen overlay rectangle (mm)
       onLanded, preserve, maxDpr, depthRes
     }) -> Promise<{ play(o), setAz(deg), setPower(0..1), paintScreen(fn), screenLoop(fn), stopScreen(), draw(), destroy() }>
   Rendering pauses while the canvas is off-screen (or the tab is hidden) and resumes on return. */
(function () {
  // DECOGEAR wordmark outlines (assets/dg-logo-allwhite.svg, viewBox 0 0 319.26 41.81), drawn as the chin decal
  const LOGO_D = ['M310.59,28.37c5-2.41,7.87-6.78,7.87-12.69,0-9.19-6.89-14.88-17.86-14.88h-18.38v40.2h11.37V9.76h6.32c4.71,0,7.06,2.18,7.06,5.92s-2.35,5.86-7.06,5.86h-6.06l13.24,19.47h12.18l-8.67-12.64Z','M237.25 41.01L252.99 0.8L264.19 0.8L280 41.01L268.17 41.01L258.51 11.95L248.85 41.01L237.25 41.01Z','M205.47,16.37h-10.07l-6.97,1h-3.26v7.5h3.94s0,0,0,0h15.2s-8.99-.05-8.98-.08h.43c-.63,4.58-4.56,7.44-9.85,7.59-1.65-.04-3.16-.35-4.51-.89-.18-.07-.35-.16-.52-.24-.13-.06-.25-.11-.37-.17-3.54-1.85-5.69-5.51-5.7-10.15,0,0,0-.02,0-.02,0-.01,0-.03,0-.04.02-5.32,2.87-9.34,7.38-10.82.16-.05.32-.11.48-.16.01,0,.02,0,.03,0,1.11-.3,2.31-.46,3.59-.46,3.85,0,6.06,1.8,8.81,4.85l7.78-7.02c-3.96-4.77-9.64-7.25-17.16-7.25-.08,0-.15,0-.23,0h0c-7.64,0-14.03,3.09-17.96,8.18-.65.83-1.24,1.71-1.74,2.65-1.58,2.93-2.46,6.33-2.46,10.07h0s0,0,0,0c0,.72.04,1.43.1,2.13.02.25.07.49.1.73.06.44.11.89.19,1.32.06.3.13.59.2.88.08.36.17.71.27,1.06.1.33.21.65.32.97.1.29.2.58.31.86.14.36.29.7.45,1.05.1.21.2.41.3.61,0,.01,0,.02.01.03.2.39.41.77.63,1.14.08.13.16.26.24.38.24.39.5.76.77,1.13.04.05.07.1.1.15.01.01.02.03.03.04,3.92,5.21,10.38,8.4,18.13,8.4h0c.08,0,.15,0,.23,0,.06,0,.11,0,.17,0,.06,0,.12,0,.17,0,.15,0,.29-.02.44-.02.31,0,.62-.02.91-.04,10.51-.52,16.01-7.01,17.62-16.46.09-.4.15-.86.2-1.36.01-.11.03-.21.05-.31h-.02c.22-2.71.19-7.25.19-7.25Z','M250.11 24.87h18.26v7.35h-18.26Z','M0,.8h19.01c13.32,0,22.46,7.75,22.46,20.1s-9.13,20.1-22.46,20.1H0V.8ZM18.55,31.93c6.83,0,11.43-4.08,11.43-11.03s-4.6-11.03-11.43-11.03h-7.18v22.05h7.18Z','M76.74,32.22v8.79h-32.28V.8h31.53v8.79h-20.27v6.78h17.86v8.5h-17.86v7.35h21.02Z','M77.96,20.91c0-12.23,9.36-20.91,22.11-20.91,7.41,0,13.38,2.7,17.28,7.58l-7.23,6.55c-2.53-3.04-5.63-4.71-9.47-4.71-6.61,0-11.2,4.59-11.2,11.49s4.59,11.49,11.2,11.49c3.85,0,6.95-1.67,9.47-4.71l7.23,6.55c-3.9,4.88-9.88,7.58-17.28,7.58-12.75,0-22.11-8.67-22.11-20.91Z','M116.5,20.91c0-12.06,9.47-20.91,22.34-20.91s22.34,8.85,22.34,20.91-9.47,20.91-22.34,20.91-22.34-8.85-22.34-20.91ZM149.69,20.91c0-6.95-4.77-11.49-10.85-11.49s-10.85,4.54-10.85,11.49,4.77,11.49,10.85,11.49,10.85-4.54,10.85-11.49Z','M205.38,16.45v-.08h-20.21v8.5h19.89c.3-2.91.32-7.73.32-8.42Z','M210.2,32.22c-1.35,3.58-3.09,6.67-5.01,8.79h26.49l3.47-8.79h-24.95Z','M206.53.8c.67.64,1.34,1.32,1.99,2.07,1.62,1.87,2.74,4.17,3.46,6.71h30.7l3.47-8.79h-39.61Z','M213.11,16.37c0,1.64-.03,5.32-.23,7.76h.02c-.02.13-.04.25-.06.37-.01.13-.03.25-.04.37h23.57l3.21-8.5h-26.47Z'];
  const VS = `
    varying vec3 vW; varying vec3 vN; varying vec2 vUv;
    void main(){ vec4 w = modelMatrix*vec4(position,1.); vW=w.xyz; vN=normalize(mat3(modelMatrix)*normal); vUv=uv;
      gl_Position = projectionMatrix*viewMatrix*w; }`;
  const FS = (n) => `
    #include <packing>
    uniform sampler2D tex[${n}]; uniform sampler2D dep[${n}]; uniform mat4 VP[${n}]; uniform vec3 camP[${n}];
    uniform vec3 eye; uniform float isScreen; uniform float power; uniform sampler2D screenTex; uniform float sigma;
    uniform sampler2D logoTex; uniform vec4 logoR; uniform vec3 logoC; uniform float logoOn; uniform float logoZ;
    varying vec3 vW; varying vec3 vN; varying vec2 vUv;
    void main(){
      vec3 N = normalize(vN); vec3 toEye = normalize(eye - vW); if (dot(N,toEye) < 0.) N = -N;
      vec3 eyeDir = normalize(vec3(eye.x, 0., eye.z));
      vec3 acc = vec3(0.); float ws = 0.;
      ${Array.from({ length: n }, (_, i) => `
      { vec4 c = VP[${i}]*vec4(vW,1.);
        if (c.w > 0.) { vec3 nd = c.xyz/c.w; vec2 uv = nd.xy*.5+.5;
          if (uv.x>=0.&&uv.x<=1.&&uv.y>=0.&&uv.y<=1.) {
            float d = nd.z*.5+.5; float sd = unpackRGBAToDepth(texture2D(dep[${i}], uv));
            float vis = clamp((sd - d + 0.0012)/0.0008, 0., 1.);
            vec4 t = texture2D(tex[${i}], uv);
            vec3 toC = normalize(camP[${i}]-vW); float facing = max(dot(N,toC), 0.);
            vec3 cd = normalize(vec3(camP[${i}].x, 0., camP[${i}].z));
            float ang = acos(clamp(dot(cd, eyeDir), -1., 1.));
            float w = vis * t.a * pow(facing, 1.5) * exp(-ang*ang/(sigma*sigma)) + 1e-6*vis*t.a;
            acc += w*t.rgb; ws += w; } } }`).join('')}
      vec3 col;
      if (ws > 1e-5) col = acc/ws;
      else { float l = .10 + .18*max(dot(N, normalize(vec3(-.4,.8,.6))),0.); col = vec3(l*.95, l*.97, l); }
      if (isScreen > 1.5 && power > 0.) {
        vec3 s = texture2D(screenTex, vUv).rgb;
        col = mix(col, s, power);
      }
      // White finish: everything except the active screen keeps the photo's shading, re-toned from black to white.
      bool face = isScreen > .5 && abs(vW.x) < 583. && vW.y > 214. && vW.y < 555.;
      if (!face) { vec3 c0 = col; float L = dot(col, vec3(.299, .587, .114)); float k = smoothstep(.02, .55, L); col = vec3(.72 + .28*k) * vec3(.985, .99, 1.);
        // the cyan accent light stays lit, exactly as on the black
        float lit = smoothstep(.06, .16, min(c0.b - c0.r, c0.g - c0.r + .04)); col = mix(col, c0, lit);
        // chin badge: the 165's light-on-black logo becomes a dark logo on the white chin
        if (logoOn < .5 && abs(vW.x) < 80. && vW.y > 186. && vW.y < 216.) { float t = smoothstep(.40, .62, L); col = mix(vec3(.826) * vec3(.985, .99, 1.), vec3(.22, .22, .24), t); } }
      // DECOGEAR chin logo: one vector decal on the chin face (the photo logos are erased from the textures; three
      // cameras put them up to 11 mm apart, which blended into a doubled, blurry logo). Sampled unconditionally for mip derivatives.
      vec2 lu = (vW.xy - logoR.xy) / (logoR.zw - logoR.xy);
      float la = texture2D(logoTex, clamp(lu, 0., 1.), -.5).a;
      la *= logoOn * step(0., lu.x) * step(lu.x, 1.) * step(0., lu.y) * step(lu.y, 1.) * step(logoZ, vW.z) * step(.2, N.z);
      col = mix(col, logoC, la);
      gl_FragColor = vec4(col, 1.);
    }`;

  // ---- mesh loading -------------------------------------------------------------------------------------
  // Packed .bin (see proto/mock/duo/pkgtest/pack.js): 'DGM1' | u32 headerLen | JSON header | Float32 pos, [Int8 normals], Uint16/32 idx
  function parseBin(ab) {
    const dv = new DataView(ab);
    if (dv.getUint32(0, false) !== 0x44474d31) throw new Error('DGSpin: not a DGM1 mesh');
    const H = dv.getUint32(4, true);
    const hdr = JSON.parse(new TextDecoder().decode(new Uint8Array(ab, 8, H)));
    const D = 8 + H;
    const parts = hdr.parts.map(p => ({
      name: p.name, screen: !!p.screen,
      pos: new Float32Array(ab, D + p.pos, p.n * 3),
      nrm: p.nrm == null ? null : new Int8Array(ab, D + p.nrm, p.n * 3),
      idx: p.it === 32 ? new Uint32Array(ab, D + p.idx, p.i) : new Uint16Array(ab, D + p.idx, p.i),
    }));
    return { parts, ov: hdr.ov, logo: hdr.logo || null };
  }
  // Legacy model.json ({panel:{v,f}, base:{v,f}, ...}): split the panel's screen faces exactly as spin.js does
  function fromLegacy(mesh) {
    const parts = [];
    for (const [k, p] of Object.entries(mesh)) {
      const V = new Float32Array(p.v), F = p.f;
      if (k !== 'panel') { parts.push({ name: k, pos: V, idx: new Uint32Array(F) }); continue; }
      const sF = [], hF = [];
      for (let i = 0; i < F.length; i += 3) {
        const a = F[i] * 3, b = F[i + 1] * 3, c = F[i + 2] * 3;
        const ux = V[b] - V[a], uy = V[b + 1] - V[a + 1], uz = V[b + 2] - V[a + 2], vx = V[c] - V[a], vy = V[c + 1] - V[a + 1], vz = V[c + 2] - V[a + 2];
        let nx = uy * vz - uz * vy, ny = uz * vx - ux * vz, nz = ux * vy - uy * vx; const l = Math.hypot(nx, ny, nz) || 1; nz /= l;
        const cz = (V[a + 2] + V[b + 2] + V[c + 2]) / 3;
        (nz > .55 && cz > -60 ? sF : hF).push(F[i], F[i + 1], F[i + 2]);
      }
      parts.push({ name: 'hull', pos: V, idx: new Uint32Array(hF) }, { name: 'screen', screen: true, pos: V, idx: new Uint32Array(sF) });
    }
    // overlay depth profile from the panel's vertices (spin.js)
    const pv = mesh.panel.v, bins = {}, BW = 8;
    for (let i = 0; i < pv.length; i += 3) { const x = pv[i], y = pv[i + 1], z = pv[i + 2]; if (y < 260 || y > 500) continue; const b = Math.round(x / BW); if (bins[b] === undefined || z > bins[b]) bins[b] = z; }
    const keys = Object.keys(bins).map(Number).sort((a, b) => a - b), k0 = keys[0];
    return { parts, ov: { bw: BW, k0, z: Array.from({ length: keys[keys.length - 1] - k0 + 1 }, (_, i) => bins[k0 + i] ?? null) } };
  }
  async function loadMesh(url) {
    const r = await fetch(url); if (!r.ok) throw new Error('DGSpin: mesh ' + r.status);
    if (/\.json(\?|$)/i.test(url)) return fromLegacy(await r.json());
    return parseBin(await r.arrayBuffer());
  }

  async function mount(canvas, opts) {
    opts = Object.assign({}, opts || {});
    const base = opts.base || '';
    const sc = Object.assign({}, opts.screen || {});
    const isPhone = (matchMedia('(pointer: coarse)').matches && Math.min(screen.width, screen.height) < 600) || /iPhone|Android.+Mobile/.test(navigator.userAgent);
    const maxDpr = opts.maxDpr || (isPhone ? 2.5 : 2);

    const [meta, mesh] = await Promise.all([
      fetch(opts.views || base + 'dgs-49hex-views.json').then(r => { if (!r.ok) throw new Error('DGSpin: views ' + r.status); return r.json(); }),
      loadMesh(opts.mesh || base + 'dgs-49hex-mesh.bin'),
    ]);
    const views = meta.views, n = views.length;
    const loader = new THREE.TextureLoader();
    loader.setCrossOrigin('anonymous');
    const texs = await Promise.all(views.map(v => new Promise((res, rej) => loader.load((opts.textures && opts.textures[v.name]) || base + v.img,
      t => { t.minFilter = THREE.LinearMipmapLinearFilter; t.generateMipmaps = true; t.anisotropy = 8; res(t); }, undefined, () => rej(new Error('DGSpin: texture ' + v.name))))));

    const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, preserveDrawingBuffer: !!opts.preserve });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, maxDpr));

    // chin logo decal (mesh header 'logo' rectangle in mm; opts.logo overrides, opts.logo === false turns it off)
    const lg = opts.logo === false ? null : (opts.logo || mesh.logo || null);
    let logoTex = null, logoR = new THREE.Vector4(0, 0, 1, 1);
    if (lg) {
      const lc = document.createElement('canvas'); lc.width = 2048; lc.height = 256;
      const PX = 64, PY = 32, lx = lc.getContext('2d');
      lx.setTransform((lc.width - 2 * PX) / 319.26, 0, 0, (lc.height - 2 * PY) / 41.81, PX, PY); lx.fillStyle = '#fff';
      for (const d of LOGO_D) lx.fill(new Path2D(d));
      logoTex = new THREE.CanvasTexture(lc); logoTex.anisotropy = renderer.capabilities.getMaxAnisotropy();
      const ex = (lg.x1 - lg.x0) * PX / (lc.width - 2 * PX), ey = (lg.y1 - lg.y0) * PY / (lc.height - 2 * PY);
      logoR = new THREE.Vector4(lg.x0 - ex, lg.y0 - ey, lg.x1 + ex, lg.y1 + ey);
    }
    const logoC = new THREE.Vector3().fromArray(opts.logoColor || [.17, .17, .19]);

    // geometry: screen faces (front-facing glass) carry a UV over their x/y box for the lit-screen texture
    const scene = new THREE.Scene();
    const screenCanvas = document.createElement('canvas'); screenCanvas.width = 1920; screenCanvas.height = 540;
    const screenTex = new THREE.CanvasTexture(screenCanvas);
    const uniformsBase = () => ({
      tex: { value: texs }, dep: { value: [] }, VP: { value: [] }, camP: { value: views.map(v => new THREE.Vector3().fromArray(v.C)) },
      eye: { value: new THREE.Vector3() }, isScreen: { value: 0 }, power: { value: 0 }, screenTex: { value: screenTex }, sigma: { value: .55 },
      logoTex: { value: logoTex }, logoR: { value: logoR }, logoC: { value: logoC }, logoOn: { value: lg ? 1 : 0 }, logoZ: { value: lg && lg.zmin != null ? lg.zmin : -6 },
    });
    const mats = [], geos = [];
    for (const g of mesh.parts) {
      const bg = new THREE.BufferGeometry(), nv = g.pos.length / 3;
      bg.setAttribute('position', new THREE.BufferAttribute(g.pos, 3));
      const uv = new Float32Array(nv * 2);
      if (g.screen) {
        let x0 = 1e9, x1 = -1e9, y0 = 1e9, y1 = -1e9;
        for (let i = 0; i < g.idx.length; i++) { const q = g.idx[i] * 3; x0 = Math.min(x0, g.pos[q]); x1 = Math.max(x1, g.pos[q]); y0 = Math.min(y0, g.pos[q + 1]); y1 = Math.max(y1, g.pos[q + 1]); }
        for (let i = 0; i < nv; i++) { uv[i * 2] = (g.pos[i * 3] - x0) / (x1 - x0); uv[i * 2 + 1] = (g.pos[i * 3 + 1] - y0) / (y1 - y0); }
      }
      bg.setAttribute('uv', new THREE.BufferAttribute(uv, 2));
      bg.setIndex(new THREE.BufferAttribute(g.idx, 1));
      if (g.nrm && !opts.computeNormals) bg.setAttribute('normal', new THREE.BufferAttribute(g.nrm, 3, true)); else bg.computeVertexNormals();
      const u = uniformsBase(); u.isScreen.value = g.screen ? 1 : 0;
      const m = new THREE.ShaderMaterial({ uniforms: u, vertexShader: VS, fragmentShader: FS(n), side: THREE.DoubleSide });
      mats.push(m); geos.push(bg);
      scene.add(new THREE.Mesh(bg, m));
    }

    // clean curved overlay for the active display area (inset inside the bezel and above the chin)
    const ov = mesh.ov, bins = {}; ov.z.forEach((z, i) => { if (z !== null) bins[ov.k0 + i] = z; });
    const BW = ov.bw, keys = Object.keys(bins).map(Number).sort((a, b) => a - b);
    const zAt = x => { const b = x / BW, i0 = Math.floor(b), i1 = i0 + 1; const z0 = bins[i0] ?? bins[keys[0]], z1 = bins[i1] ?? z0; return z0 + (z1 - z0) * (b - i0); };
    const SX = sc.screenX || 583, SY0 = sc.screenY0 || 214, SY1 = sc.screenY1 || 555, COLS = 96;
    const ovg = new THREE.BufferGeometry(); const P = [], U = [], I = [];
    for (let c = 0; c <= COLS; c++) { const x = -SX + 2 * SX * c / COLS, z = zAt(x) + 1.2; P.push(x, SY0, z, x, SY1, z); U.push(c / COLS, 0, c / COLS, 1); }
    for (let c = 0; c < COLS; c++) { const a = c * 2; I.push(a, a + 2, a + 1, a + 1, a + 2, a + 3); }
    ovg.setAttribute('position', new THREE.Float32BufferAttribute(P, 3)); ovg.setAttribute('uv', new THREE.Float32BufferAttribute(U, 2)); ovg.setIndex(I);
    geos.push(ovg);
    const ovMat = new THREE.MeshBasicMaterial({ map: screenTex, transparent: true, opacity: 0, side: THREE.FrontSide, depthWrite: false, depthTest: false });
    const ovMesh = new THREE.Mesh(ovg, ovMat); ovMesh.renderOrder = 2; ovMesh.visible = false;

    // per-view depth maps from the exact factory cameras
    const VPs = [], deps = [], rts = [];
    const depthMat = new THREE.MeshDepthMaterial({ depthPacking: THREE.RGBADepthPacking, side: THREE.DoubleSide });
    const DR = opts.depthRes || 1536;
    for (const v of views) {
      const cam = new THREE.Camera();
      cam.projectionMatrix.fromArray(v.P); cam.projectionMatrixInverse.copy(cam.projectionMatrix).invert();
      cam.matrixWorldInverse.fromArray(v.V); cam.matrixWorld.copy(cam.matrixWorldInverse).invert(); cam.matrixAutoUpdate = false;
      const w = DR, h = Math.round(DR * v.size[1] / v.size[0]);
      const rt = new THREE.WebGLRenderTarget(w, h, { minFilter: THREE.NearestFilter, magFilter: THREE.NearestFilter });
      scene.overrideMaterial = depthMat; renderer.setRenderTarget(rt); renderer.setClearColor(0xffffff, 1); renderer.clear(); renderer.render(scene, cam);
      deps.push(rt.texture); rts.push(rt);
      VPs.push(new THREE.Matrix4().fromArray(v.P).multiply(new THREE.Matrix4().fromArray(v.V)));
    }
    scene.overrideMaterial = null; renderer.setRenderTarget(null); renderer.setClearColor(0x000000, 0);
    depthMat.dispose();
    scene.add(ovMesh);
    for (const m of mats) { m.uniforms.dep.value = deps; m.uniforms.VP.value = VPs; }

    // orbit camera (same height and pitch as the factory renders)
    const cam = new THREE.PerspectiveCamera(22, 1, 50, 20000);
    const target = new THREE.Vector3(0, 300, -30);
    let az = 390, el = -2.5;

    // ---- visibility gating: no GPU work while off-screen or in a hidden tab ----
    let onScreen = true, dirty = false, dead = false;
    const visible = () => onScreen && !document.hidden && !dead;
    function size() {
      const r = canvas.getBoundingClientRect(); if (!r.width || !r.height) return;
      renderer.setSize(r.width, r.height, false); cam.aspect = r.width / r.height; cam.updateProjectionMatrix();
      const t = Math.tan(THREE.MathUtils.degToRad(cam.fov / 2));
      cam.userData.dist = Math.max(1420 / (2 * t * cam.aspect), 720 / (2 * t));
    }
    function render() {
      if (!cam.userData.dist) return;
      const a = THREE.MathUtils.degToRad(az), e = THREE.MathUtils.degToRad(el), d = cam.userData.dist;
      cam.position.set(target.x + d * Math.sin(a) * Math.cos(e), target.y + d * Math.sin(e), target.z + d * Math.cos(a) * Math.cos(e));
      cam.lookAt(target);
      for (const m of mats) m.uniforms.eye.value.copy(cam.position);
      renderer.render(scene, cam);
    }
    function draw() { if (visible()) { dirty = false; render(); } else dirty = true; }

    let power = 0;
    function setPower(p) { power = p; for (const m of mats) m.uniforms.power.value = p; ovMat.opacity = p; ovMesh.visible = p > 0.001; }

    // screen content loop: paused (not ticking) while off-screen, resumes on return
    let loop = 0, loopFn = null, loopT0 = 0;
    function tick(now) { loop = 0; if (!loopFn || !visible()) return; loopFn(screenCanvas.getContext('2d'), screenCanvas.width, screenCanvas.height, (now - loopT0) / 1000); screenTex.needsUpdate = true; draw(); loop = requestAnimationFrame(tick); }
    function screenLoop(fn) { cancelAnimationFrame(loop); loopFn = fn; loopT0 = performance.now(); tick(loopT0); }
    function stopScreen() { cancelAnimationFrame(loop); loop = 0; loopFn = null; }
    function paintScreen(fn) { fn(screenCanvas.getContext('2d'), screenCanvas.width, screenCanvas.height); screenTex.needsUpdate = true; }

    function resume() { if (!visible()) return; if (loopFn && !loop) loop = requestAnimationFrame(tick); if (dirty) draw(); }
    let io = null, ro = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(es => { for (const e of es) onScreen = e.isIntersecting; resume(); }, { rootMargin: '200px 0px' });
      io.observe(canvas);
    }
    const onVis = () => resume();
    document.addEventListener('visibilitychange', onVis);
    const onResize = () => { size(); draw(); };
    if ('ResizeObserver' in window) { ro = new ResizeObserver(onResize); ro.observe(canvas); } else addEventListener('resize', onResize);
    size(); render();

    const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    let raf = 0;
    function play(o) {
      o = o || {}; cancelAnimationFrame(raf); setPower(0);
      const from = o.from ?? 180, to = o.to ?? 0, dur = o.dur ?? 2300, t0 = performance.now();
      return new Promise(res => {
        (function step(now) {
          const t = Math.min(1, (now - t0) / dur); az = from + (to - from) * ease(t); draw();
          if (t < 1) raf = requestAnimationFrame(step);
          else {
            const p0 = performance.now();
            (function on(now2) { const q = Math.min(1, (now2 - p0) / 700); setPower(q * q * (3 - 2 * q)); draw(); if (q < 1) raf = requestAnimationFrame(on); else { res(); opts.onLanded && opts.onLanded(); } })(p0);
          }
        })(t0);
      });
    }
    // drag to turn
    let drag = null;
    const pd = e => { drag = { x: e.clientX, az }; canvas.setPointerCapture(e.pointerId); };
    const pm = e => { if (!drag) return; az = drag.az - (e.clientX - drag.x) * .35; draw(); };
    const pu = () => { drag = null; };
    canvas.addEventListener('pointerdown', pd); canvas.addEventListener('pointermove', pm); canvas.addEventListener('pointerup', pu); canvas.addEventListener('pointercancel', pu);

    function destroy() {
      dead = true; cancelAnimationFrame(raf); stopScreen();
      io && io.disconnect(); ro ? ro.disconnect() : removeEventListener('resize', onResize);
      document.removeEventListener('visibilitychange', onVis);
      canvas.removeEventListener('pointerdown', pd); canvas.removeEventListener('pointermove', pm); canvas.removeEventListener('pointerup', pu); canvas.removeEventListener('pointercancel', pu);
      for (const g of geos) g.dispose(); for (const m of mats) m.dispose(); ovMat.dispose();
      for (const t of texs) t.dispose(); for (const r of rts) r.dispose(); screenTex.dispose(); if (logoTex) logoTex.dispose(); renderer.dispose();
    }
    return { play, setAz: d => { az = d; draw(); }, setPower: p => { setPower(p); draw(); }, paintScreen, screenLoop, stopScreen, draw, destroy };
  }
  window.DGSpin = { mount };
})();
